<template>
  <div id="loading" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 0; align-items: center; justify-content: center;">
    <div style="background-color: rgb(255, 255, 255); position: absolute; top: 0; bottom: 0; left: 0; right: 0; opacity: 0.5;"></div>
    <v-progress-circular
      :size="100"
      color="primary"
      indeterminate
      style="height: 50px; width: 50px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    ></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: 'Loading', 
}
</script>
